import { gql } from '@apollo/client';

export const GET_SPECIAL_ASSISTANCE_OPTIONS = gql`
  query SpecialAssistanceOptions($bookingReference: String!) {
    specialAssistanceOptions(bookingReference: $bookingReference) {
      id
      name
    }
  }
`;

export const GET_EXTRAS_AND_SPECIAL_ASSISTANCE_OPTIONS = gql`
  query extrasAndSpecialAssistanceOptions($bookingReference: String!) {
    extrasAndSpecialAssistanceOptions(bookingReference: $bookingReference) {
      currency
      extras {
        id
        name
        passengerTypes
        price
      }
      specialAssistance {
        id
        name
      }
    }
  }
`;

export const GET_EXTRA_PRODUCTS = gql`
  query getExtraProducts(
    $currency: String!
    $segments: [InputSegment!]!
    $passengers: [InputPassenger!]!
    $types: [String!]!
    $isAftersales: Boolean
  ) {
    getExtraProducts(currency: $currency, segments: $segments, passengers: $passengers, types: $types, isAftersales: $isAftersales) {
      currency
      specialAssistance {
        id
        name
        passengerTypes
        passengers
        segments
        paxSegments {
          passengerId
          segments
        }
        price
      }
    }
  }
`;

export const GET_LUGGAGE_PRODUCTS = gql`
  query journeySearchForLuggageExchange(
    $exchangeItems: [Int!]!
    $reference: String!
    $origin: String!
    $destination: String!
    $passengers: [InputPassengerBrief]
    $outboundDate: String
    $inboundDate: String
    $trainNumbers: [String]
    $currency: String
  ) {
    journeySearchForLuggageExchange(
      reference: $reference
      origin: $origin
      destination: $destination
      inboundDate: $inboundDate
      outboundDate: $outboundDate
      passengersList: $passengers
      exchangeItems: $exchangeItems
      currency: $currency
      intention: "upgrade"
    ) {
      outbound {
        ...luggageSearch
      }
      inbound {
        ...luggageSearch
      }
    }
  }

  fragment luggageSearch on Offer {
    origin {
      name
      city
      uic
    }
    destination {
      name
      city
      uic
    }
    journeys(hideIndirectTrainsWhenDisruptedAndCancelled: true, hideDepartedTrains: true, trainNumbers: $trainNumbers) {
      ...luggageJourney
    }
  }

  fragment luggageTiming on Timing {
    date
    duration
    arrivalDate
    departureDate
    departureTime: departs
    arrivalTime: arrives
    isoDate
  }

  fragment luggageJourney on Journey {
    timing {
      ...luggageTiming
    }
    fares {
      flexibilityLevel
      classOfService {
        name
        code
      }
      prices {
        displayPrice
        total
        child
        adult
        senior
        youth
      }
      seats
      legs {
        origin {
          uic
          name
        }
        destination {
          uic
          name
        }
        serviceName
        serviceType {
          code
          brandCode
          name
        }
        serviceIdentifier
        timing {
          ...luggageTiming
        }
        addOnProducts {
          tariffCode
          passengerId
          passengerAgeGroup {
            type
            name
          }
          isFareAddOn
          tariffCode
          bucketCode
          loyaltyPoints
          name
          code
          price
          originalPrice
          inventoryUnits
          physicalAvailability
          availabilityOfClassOfService
        }
      }
    }
  }
`;
